/* src/app/ship/pickup-locations/components/pickup-location/pickup-location.component.scss */
table.hours-of-operation {
  --mat-table-header-headline-size: .8rem;
  --mat-table-header-container-height: 2rem;
  --mat-table-row-item-label-text-size: .7rem;
  --mat-table-row-item-container-height: 1rem;
  border: solid thin rgba(0, 0, 0, 0.12);
}
.pickup-location-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.5em;
}
.pickup-location-title .business-name {
  font-size: 1em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}
.pickup-location-title .previously-used {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.5rem;
}
.pickup-location-title .previously-used [class*=material-symbols-] {
  color: #0A8080;
}
.pickup-location-title .previously-used .description {
  background-color: #C2E3E2;
  color: black;
  font-size: 0.625em;
  line-height: 1.11881;
  border-radius: 0.1875em;
  padding: 0.15em 0.25em;
}
.address-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-between;
}
.address-info .distance {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
  column-gap: 0.25em;
  padding: 0 1em;
}
.address,
.distance {
  font-size: 0.8em;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
}
.actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  column-gap: 1em;
  padding-top: 0.5em;
}
.actions ::ng-deep .mat-mdc-button-base {
  --mdc-outlined-button-container-height: 1.75rem !important;
  font-size: 0.75em;
}
.actions ::ng-deep .mat-mdc-button-base .mdc-button__label [class*=material-symbols-] {
  font-size: 1.5em;
}
.actions .hours-toggle .flip {
  transform: rotateX(180deg);
  transition: transform 0.225s cubic-bezier(0.4, 0, 0.2, 1);
}
.actions .map-link {
  font-weight: 500;
  text-decoration: none;
}
span.closed {
  color: #d50000;
}
span.not-available {
  color: #d5cfc9;
}
:host(.disabled) {
  pointer-events: none;
  color: #BFB8AF;
}
:host(.disabled) .business-name,
:host(.disabled) .address,
:host(.disabled) .distance,
:host(.disabled) .actions .mdc-button {
  color: #BFB8AF;
}
:host(.disabled) .actions .mdc-button {
  border-color: #BFB8AF;
}
:host(.pickup-location) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=pickup-location.component.css.map */
